import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import funcoesGerais from '../../../funcoes/funcoesGerais';
import { PedidoConsultaElement } from '../../../interfaces/pedido.consulta';


@Component({
  selector: 'app-gerar-canhotos-dialog',
  templateUrl: './gerar-canhotos-dialog.html',
  styleUrls: ['./gerar-canhotos-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class GerarCanhotosDialog implements OnInit {
  uid;
  canhotosForm: FormGroup;
  minDate: Date = new Date();

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<GerarCanhotosDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { pedidos: PedidoConsultaElement[] }
  ) {
    this.uid = localStorage.getItem('uid');
    this.minDate.setDate(new Date().getDate() + 1);
  }

  ngOnInit(): void {
    this.canhotosForm = this.formBuilder.group({
      quantidade: [this.data.pedidos.length, [Validators.required, Validators.min(1)]],
    });
  }

  confirmarGerarCanhotos() {
    try {
      const dados: PedidoConsultaElement[] = this.data.pedidos;
      let auxCodigoImpressao = '';
      for (let i = 0; i < dados.length; i++) {

        auxCodigoImpressao += `
        <div class="receipt-main">
  <div class="row">
    <div class="col-sm">
      <p class="receipt-title">Confirmo recebimento do boleto</p>

      <div class="row">
        <div class="col-sm">
          <span class="receipt-label text-large">Pedido:</span>
          <span class="text-large">
            ${dados[i].ID}
          </span>
        </div>

        <div class="col-auto">
          <span class="text-large receipt-label">R$</span>
          <span class="text-large">${dados[i].ValorRealString},${dados[i].ValorCentavosString}</span>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-auto">
          <span>Beneficiário:</span>
          <span>${dados[i].Nome}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-auto">
          <span>Recebi o boleto em mãos referente ao pedido realizado na data: ${dados[i].Data}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-auto">
          <p>Quantidade de boletos: ${dados[i].NumeroParcelas}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-sm text-right">
          <p style="font-size: medium;">${dados[i].Cidade}, ${funcoesGerais.tratarData(new Date())}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <hr style="border: 0; width: 100%; color: #000; background-color: #000; height: 2px; border-top: solid 1px #000 !important;">
        </div>
      </div>

      <div class="row" style="margin-top: -10px;">
        <div class="col-sm text-center">
          <p>Ass. responsável</p>
        </div>
      </div>

    </div>
  </div>

</div>

        `;
      }

      let windowPopup: any = window.open('Pedido', '_blank', 'width=1000,height=' + (1000)); //Uma impressão com um único produto, === 320 de altura, a cada produto aumentar 10px
      windowPopup.document.open();


      windowPopup.document.write(
        '<html style="width: auto; margin: 16px">' +
        '<head><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"></head>'
        + '<style>body { padding: 50px; } * { box-sizing: border-box; } .receipt-main { display: inline-block; width: 100%; padding: 8px; font-size: 12px; border: 1px solid #000; } .receipt-title { text-align: center; text-transform: uppercase; font-size: 20px; font-weight: 600; margin: 0; } .receipt-label { font-weight: 600; } .text-large { font-size: 16px; } .receipt-section { margin-top: 10px; } .receipt-footer { text-align: center; background: #ff0000; } .receipt-signature { margin: 50px 0 0 0; padding: 0 50px; background: #fff; .receipt-line { margin-bottom: 10px; border-bottom: 1px solid #000; } p { text-align: center; margin: 0; } }</style>'
        + '<body>'
      );

      windowPopup.document.write(auxCodigoImpressao);

      windowPopup.document.write(
        '</body>' +
        '</html>'
      );
      windowPopup.document.close();
      windowPopup.focus();
      setTimeout(() => {
        windowPopup.print();
      }, 1500);

    } catch (error) {
      this.toastr.error(`Falha ao realizar a impressão: ${error}.`, 'Error', { progressBar: true, positionClass: 'toast-top-center', });
    }

    this.cancelar();
  }

  cancelar() {
    this.dialogRef.close();
  }

  // convenience getter for easy access to form fields
  get f() { return this.canhotosForm.controls; }

}
